import Spinner from './Swrapper.vue';
export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinners/swrapper/index.ts